export default __webpack_public_path__ + "e857085ae81f67de9e140d6bfa5efde9.png";